import {addHours} from 'date-fns'

// This method is meant to be used when the date has not hour information
// Example: 2020-01-18T00:00:00.000Z
export function adjustsDate(dateStr: string):Date {
    return addHours(new Date(dateStr), 3)
}
